<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fmh" id="_idParaDest-3"><a id="_idTextAnchor002"></a><a href="#/text/9780062847355_Contents#r_idParaDest-3"><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix">Epigraph</span></a></h2>
<p class="poem"><i>In a shrine of ancients past</i></p>
<p class="poem"><i>When the dark has stolen the throne,</i></p>
<p class="poem"><i>The Goddess holds the end of times</i></p>
<p class="poem"><i>And there she waits alone.</i></p>
<p class="poem"><i>And when she fails its heart will beat</i></p>
<p class="poem"><i>And consume the kingdom bright,</i></p>
<p class="poem"><i>For no soul lives to tell the tale</i></p>
<p class="poem"><i>Of a star to shine the light.</i></p>
<p class="poem">—“The Goddess’s Legacy,”</p>
<p class="poem"><i>The Cantos of Light</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062847355_Epigraph.vue?264db64d